import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Common form with email to validate */
export interface EmailQueryInterface {
  /** Email to validate */
  email: string;
}

/** Common form with email to validate - DTO schema */
export const EmailQueryDto = SerdeDtoClass.create<EmailQueryInterface>(CommonDtoKeysEnum.EMAIL_QUERY_DTO, {
  email: {
    label: 'Email',
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
});
